import React, { useState } from 'react'
import { Table } from '../../../../components/Tables/Table';
import { FiEdit, FiEye, FiRefreshCcw, FiTrash2 } from 'react-icons/fi';
import { devices_status, devices_status_colors } from '../../../../app/Constants';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { icosIndicators } from '../../../../app/Paths';
import { activateDevice, deactivateDevice } from '../../../store/Thunk';
import { Loading } from '../../../../components/Loading';
import { M_NewDevice } from './M_NewDevices';


export const Devices = () => {

  //  const { isLoading, catalogProduct, msg, status } = useSelector(state => state.products);
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = (type) => {
    // setSearchType(type);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // setSearchType(null);
  };


  const dispatch = useDispatch();
  const { isLoading, devices, idCustomer } = useSelector(state => state.customerDetail);
  const [selectedItem, setSelectedItem] = useState(null);

  const handledDelete = (id) => {

    console.log(id);

    Swal.fire({
      title: 'Atención',
      text: "Está por desactivar un equipo, ¿Desea de continuar con esta acción?",
      icon: 'question',
      customClass: {
        confirmButton: 'btn btn-primary  me-2',
        cancelButton: 'btn btn-secondary'
      },
      showCancelButton: true, // <-- ¡Este es importante!
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'No, cancelar',
      buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deactivateDevice(id, idCustomer));
      }
    })
  }

  const handledActive = (id) => {
    console.log(id);

    Swal.fire({
      title: 'Atención',
      text: "Está por activar un equipo, ¿Desea de continuar con esta acción?",
      icon: 'question',
      customClass: {
        confirmButton: 'btn btn-primary  me-2',
        cancelButton: 'btn btn-secondary'
      },
      showCancelButton: true, // <-- ¡Este es importante!
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'No, cancelar',
      buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(activateDevice(id, idCustomer));
      }
    })
  }


  const listDevices = [...devices];

  let columns = [
    {
      header: 'ID',
      dataIndex: 'ID',
      classHeader: 'text-center',
      classRow: 'text-center',
    },

    {
      header: 'MARCA',
      dataIndex: 'MARCA',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'CATEGORIA',
      dataIndex: 'CATEGORIA',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'EQUIPO',
      dataIndex: 'MODELO',
      classHeader: 'text-start',
      classRow: 'text-start',
    },

    {
      header: 'SERIE',
      dataIndex: 'NO_SERIE',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'S.O.',
      dataIndex: 'SIS_OP',
      classHeader: 'text-center',
      classRow: 'text-center',
    },
    {
      header: 'CANT. ORDENES',
      dataIndex: 'CONTEO_ORDENES',
      classHeader: 'text-center',
      classRow: 'text-center',
    },
    {
      header: 'FECHA ULT. ORDEN',
      dataIndex: 'ULTIMA_ORDEN',
      classHeader: 'text-center',
      classRow: 'text-center',
    },
    {
      header: 'ESTADO',
      dataIndex: 'ESTADO',
      classHeader: 'text-center',
      classRow: 'text-center',
      renderer: (value, row) => {
        const code = Number(value);
        const folio = row.FOLIO_ORDEN_ACTIVA;

        const hasActiveOrder = folio && Number(folio) !== 0;

        if (hasActiveOrder) {
          return (
            <span className="badge bg-success text-white">
              ORDEN ACTIVA: {folio}
            </span>
          );
        }

        return (
          <span className={`badge text-white ${devices_status_colors[code]}`}>
            {devices_status[code]}
          </span>
        );
      }
    },
    {
      header: 'ACCIONES',
      dataIndex: 'ESTADO',
      classHeader: 'text-center',
      classRow: 'text-center',
      renderer: (value, row) => {
        const estado = Number(row.ESTADO);
        const isDeleted = Number(row.ESTADO) === 2;
        const folio = row.FOLIO_ORDEN_ACTIVA;
        const hasActiveOrder = folio && Number(folio) !== 0;
        const isBlockedState =
          estado === 11 ||      // EQUIPO ABANDONADO
          estado === 3 ||       // ORDEN EN PROCESO
          hasActiveOrder;       // ORDEN ACTIVA

        if (isBlockedState) {
          return (
            <span className="text-muted small">
              -
            </span>
          );
        }

        return (
          <div className="btn-group border-0" role="group">
            {isDeleted ? (
              <button type="button" className="btn btn-outline-success border-0"
                onClick={() => handledActive(row.ID)}
                title="Activar equipo"
              >
                <FiRefreshCcw size={20} />
              </button>
            ) : (
              <button type="button" className="btn btn-outline-danger border-0"
                onClick={() => handledDelete(row.ID)}
                title="Desactivar equipo"
              >
                <FiTrash2 size={20} />
              </button>
            )}
          </div>
        );
      }
    }
  ];

  return (
    <>
      {showModal && (<M_NewDevice onClose={handleCloseModal} />)}
     
          <div className='row'>
            <div className='col-12 mb-3'>
              <img src={icosIndicators['devices']} className="img-fluid" width={28} alt="devices" />
              <span className='ms-2 me-3 fw-bold h4'>Equipos</span>
            </div>

            <div className='col-3 mb-3'>
              <button type="button" className="btn btn-outline-primary" onClick={() => handleOpenModal()}>Nuevo equipo</button>
            </div>

            <div className='col-12'>
              <Table
                columns={columns}
                data={listDevices}
                function_={(row) => { setSelectedItem(row.ID) }}
                placeholderSearch="Buscar por: ID, Tipo, Marca, Sistema operativo"
                showPagination={true}
                showControls={true}
                showTotals={false}
              />
            </div>


          </div>
      
    </>
  )
}
